<template>
  <div ref="tankChart"></div>
</template>

<script>
import 'echarts/lib/chart/line';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/dataZoom';
import 'echarts/lib/component/title';
import echarts from 'echarts';
import 'echarts-gl';
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex';

export default {
  name: 'TankChart',
  props: {
    min: {
      type: String,
    },
    max: {
      type: String,
    },
  },
  data() {
    return {
      tankChart: {},
    };
  },
  methods: {
    ...mapMutations('Engineering', ['setEchartResizeKey']),
    initChart() {
      this.tankChart = echarts.init(this.$refs.tankChart);
      this.tankChart.setOption(this.option);
    },
  },
  computed: {
    resizekey() {
      return this.$store.state.Engineering.echartResizeKey;
    },
    yMax() {
      return parseFloat(this.max);
    },
    yMin() {
      return parseFloat(this.min);
    },
    option() {
      const option = {
        grid: {
          top: 10,
          left: 22,
          right: 0,
          bottom: 20,
        },
        xAxis: {
          type: 'category',
          data: ['信号名'],
        },
        yAxis: {
          type: 'value',
          min: this.yMin,
          max: this.yMax,
        },
        series: [{
          data: [7],
          type: 'bar',
        }],
      };
      return option;
    },
  },
  watch: {
    resizekey() {
      this.tankChart.resize();
    },
  },
  mounted() {
    this.initChart();
    this.setEchartResizeKey();
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/echarts/TankChart.vue